import { useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const KomIgang = () => {
  const { language, setLanguage, content } = useLanguage();

  useEffect(() => {
    // Load Typeform script once if not present
    const existingScript = document.querySelector(
      'script[src*="typeform.com/next/embed.js"]'
    ) as HTMLScriptElement | null;

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = '//embed.typeform.com/next/embed.js';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }

    // No cleanup to avoid removing script used on other pages
  }, []);

  return (
    <>
      <Header 
        language={language} 
        onLanguageChange={setLanguage} 
        content={content.header} 
      />
      <main className="min-h-screen pt-20">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Kom igång
            </h1>
            <p className="text-xl text-muted-foreground mb-8">
              Berätta om ditt projekt så återkommer vi med ett förslag
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div data-tf-live="01K5MNF3JG9A4X1VACS051H1HX"></div>
          </div>
        </div>
      </main>
      <Footer content={content.footer} />
    </>
  );
};

export default KomIgang;